// @nuxtjs/i18n 的 locales → 語系碼陣列（純函式，無 Nuxt runtime 依賴）。
//
// 原本 middleware / plugin / 元件各自寫一次 `$i18n?.locales?.value?.map((item) => item.code) || []`，
// 形狀還不完全一致（有的用 `item.code || item`、有的沒有 optional chaining，$i18n 缺席時直接 throw），
// 導致同一份語系清單在不同層可能推導出不同結果。統一由此推導。
//
// locales 同時接受 ref 與已解開的陣列：`$i18n.locales` 與 `useI18n()` 的 `locales` 都是 ref，
// 但呼叫端有時已經取過 `.value`。元素可能是 `{ code }` 物件或純字串碼（設定檔兩種寫法都合法）。
export const toLocaleCodes = (locales) => {
  const list = Array.isArray(locales) ? locales : locales?.value
  return Array.isArray(list) ? list.map((item) => item?.code ?? item) : []
}
